import { type Types } from '@fiverr-private/theme';
import { scrollbarColor } from './styles.ve.css';

export const getStylingProps = ({ isDark }): Types.ContainerProps => ({
    boxShadow: 'aa',
    paddingY: '2',
    borderRadius: isDark ? '2xl' : 'lg',
    backgroundColor: isDark ? 'black' : 'white',
    ...(isDark && {
        borderColor: 'white_20',
        borderWidth: 'sm',
        borderStyle: 'solid',
    }),
    className: scrollbarColor,
});
